import { normalizePlanValue } from './subscriptionPlan';
import type { Session } from '../session';

type UserSessionResponse = {
  // Optional during a coordinated client/server rollout.
  subjectId?: string;
  workspaceId?: string;
  email: string;
  slug: string | null;
  publicSlug: string | null;
  indexable: boolean;
  active: boolean;
  subscriptionPlan: string | null;
  subscriptionStatus: 'ACTIVE' | 'PAST_DUE' | 'CANCELED' | null;
  sessionExpiresAt: string;
  canSyncToCloud: boolean;
  hasPhysicalCard: boolean;
  entitlements?: Session['entitlements'];
  limits?: Session['limits'];
};

const toSession = (response: UserSessionResponse): Session => ({
  ...(typeof response.subjectId === 'string' && response.subjectId.length > 0 &&
    typeof response.workspaceId === 'string' && response.workspaceId.length > 0
    ? { subjectId: response.subjectId, workspaceId: response.workspaceId } : {}),
  email: response.email,
  slug: response.slug,
  publicSlug: response.publicSlug,
  indexable: response.indexable,
  active: response.active,
  subscriptionPlan: normalizePlanValue(response.subscriptionPlan) ?? null,
  subscriptionStatus: response.subscriptionStatus,
  expiresAt: response.sessionExpiresAt,
  canSyncToCloud: Boolean(response.canSyncToCloud),
  hasPhysicalCard: Boolean(response.hasPhysicalCard),
  entitlements: response.entitlements,
  limits: response.limits
});

export { toSession };
export type { UserSessionResponse };
